import React from 'react';

import {SubmitHandler, useForm} from 'react-hook-form';
import {t} from '@lingui/core/macro';
import {useSelector} from 'react-redux';

import {INewPasswordForm, isPasswordSettingSelector} from 'entities/user';

import Button from 'shared/ui/Button/Button/Button';

import InputPassword from '../../../../../shared/ui/Input/InputPassword';

import FormGroupWithError from '../../../../../shared/ui/FormGroup/FormGroupWithError';

import styles from '../Auth.module.scss';

interface INewPasswordFormProps {
    onSubmit: SubmitHandler<INewPasswordForm>
}

const NewPasswordForm: React.FC<INewPasswordFormProps> = ({onSubmit}) => {
    const isLoading = useSelector(isPasswordSettingSelector);
    const {register, handleSubmit, formState, control} = useForm<INewPasswordForm>({mode: 'onChange'});
    const {errors, isValid, isDirty} = formState;

    return (
        <>
            <div>
                <h2 className={styles.title}>
                    {t`Новый пароль`}
                </h2>
            </div>

            <form onSubmit={handleSubmit(onSubmit)}>
                <FormGroupWithError error={errors?.password?.message}>
                    <InputPassword
                        control={control}
                        register={register}
                        placeholderToLabel
                    />
                </FormGroupWithError>

                <FormGroupWithError error={errors?.password_confirmation?.message}>
                    <InputPassword
                        register={register}
                        control={control}
                        name="password_confirmation"
                        placeholder={t`Подтверждение пароля`}
                        placeholderToLabel
                    />
                </FormGroupWithError>

                <div className="form-group">
                    <Button
                        type="submit"
                        loading={isLoading}
                        block
                        disabled={!isDirty || !isValid}
                    >
                        {t`Изменить пароль`}
                    </Button>
                </div>
            </form>
        </>
    );
};

export default NewPasswordForm;